import React from 'react'

export default () => (
	<>
		<path id="Tracé_139" data-name="Tracé 139" d="M0,0H19.313V19.313H0Z" fill="none" />
		<rect id="Rectangle_1906" data-name="Rectangle 1906" width="2" height="19" transform="translate(0 0.313)" fill="#172f50" />
		<rect id="Rectangle_1907" data-name="Rectangle 1907" width="19" height="2" transform="translate(0 17.313)" fill="#172f50" />
		<rect id="Rectangle_1934" data-name="Rectangle 1934" width="8" height="8" transform="translate(11 0.313)" fill="#eb242c" />
	</>
)